import React from 'react';
import { useTheme } from '@thd-olt-component-react/theme-provider';
import { CustomerAccountNavigationWrapper } from '../CustomerAccountNavigationWrapper';
import { CustomerAccountNavigation } from '../CustomerAccountNavigation';
import { NavigationDrawerContent } from './NavigationDrawerContent';
import { dataModel } from '../data-model';

export const NavigationDrawer = ({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) => {
  const theme = useTheme(CustomerAccountNavigation);
  const { isStoreFront } = theme.props;

  return (
    <CustomerAccountNavigationWrapper
      skipQuery={!open}
      isStoreFront={isStoreFront}
    >
      {({ concreteRouteGroups }) => (
        <NavigationDrawerContent
          concreteRouteGroups={concreteRouteGroups}
          open={open}
          onClose={onClose}
        />
      )}
    </CustomerAccountNavigationWrapper>
  );
};

NavigationDrawer.displayName = 'NavigationDrawer';

NavigationDrawer.dataModel = dataModel;
